
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"256","cy":"256","r":"256","fill":"#6DA544"}}),_c('g',{attrs:{"fill":"#F0F0F0"}},[_c('path',{attrs:{"d":"M144.696 306.087c0 18.441 14.95 33.391 33.391 33.391h100.174c0 15.368 12.458 27.826 27.826 27.826h33.391c15.368 0 27.826-12.458 27.826-27.826v-33.391H144.696zm225.391-161.391v77.913c0 12.275-9.986 22.261-22.261 22.261v33.391c30.687 0 55.652-24.966 55.652-55.652v-77.913h-33.391zm-239.304 77.913c0 12.275-9.986 22.261-22.261 22.261v33.391c30.687 0 55.652-24.966 55.652-55.652v-77.913h-33.391v77.913z"}}),_c('path',{attrs:{"d":"M320 144.696h33.391v77.913H320zM269.913 189.217c0 3.069-2.497 5.565-5.565 5.565s-5.565-2.497-5.565-5.565v-44.522h-33.391v44.522c0 3.069-2.497 5.565-5.565 5.565s-5.565-2.497-5.565-5.565v-44.522H180.87v44.522c0 21.481 17.476 38.957 38.957 38.957a38.72 38.72 0 0022.261-7.016 38.726 38.726 0 0022.261 7.016c1.666 0 3.304-.117 4.915-.322-2.366 9.749-11.146 17.017-21.611 17.017v33.391c30.687 0 55.652-24.966 55.652-55.652v-77.913h-33.391v44.522z"}}),_c('path',{attrs:{"d":"M180.87 244.87h50.087v33.391H180.87z"}})])])
          )
        }
      }
    